export const maxNameLength = 100
export const maxCommandLineParameterLength = 500
export const maxURLPathLength = 1500
export const maxFilePathLength = 255
export const maxDefaultEllipsisLength = 150
